import { trace } from '@opentelemetry/api';

export default class HoneycombTracer {
  constructor() {
    this.tracer = trace.getTracer('honeycomb-web-instrumentation');
  }

  startActiveSpan(...args) {
    this.tracer.startActiveSpan(...args);
  }
}
